import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SignatureService } from '../../providers/signature.service';
import { DialogService } from '../dialog.service';

@Component({
  selector: 'app-signaturedialog',
  templateUrl: './signaturedialog.component.html',
  styleUrls: ['./signaturedialog.component.css']
})
export class SignaturedialogComponent implements OnInit {
  @Input() items: any = [];
  itemToDelete = null;
  deleting = false;
  error = false;

  @Input() doc: any;
  @Input() page: any;
  @Input() onAddSignatureById: any;
  @Input() onAddPenSignature: any;
  @Input() onAddImageSignature: any;
  @Input() onAddTextSignature: any;

  penSignatureColor = 0xFF000000;
  penSignatureWidth = 4;

  penSignaturePoints = [];
  penSignatureHasContent = false;
  
  lastCanvasWidth = 0;
  refreshPenSignature = 0;

  newPenSignatureTitle = "New pen siganture";
  newImgSignatureTitle = "New image signature";
  newTxtSignatureTitle = "New text signature";

  tabs = {
    SIGNATURE_PEN: "sig_pen",
    SIGNATURE_IMG: "sig_img",
    SIGNATURE_TEXT: "sig_text"
  };

  openedTab = this.tabs.SIGNATURE_TEXT;

  saveSignature = this.items.length < 3;

  dragClass = "dropHere-inactive";

  imgSigLoading = false;
  imagSignature = undefined;
  eventListenerActive = false;

  textSignatureFamily = "Allura";

  imageSignature: any;
  newTextSignature: any;
  errorMsg: any;

  editorActive: boolean = false;

  @HostListener("dragover", ["$event"]) public onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragClass = 'dropHere-active';
  }

  @HostListener("dragleave", ["$event"]) public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragClass = 'dropHere-inactive';
  }

  @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();

    let files: File[] = [];
    let firstFile: File;
    for (let i = 0; i < evt.dataTransfer.files.length; i++) {
      firstFile = evt.dataTransfer.files[0];

    }

    this.upload(firstFile, true);
    this.dragClass = 'dropHere-inactive';
  }
  constructor(public activeModal: NgbActiveModal,
    private translateService: TranslateService,
    private dialogs: DialogService,
    private signature: SignatureService) { }

  ngOnInit(): void {
    this.activate();
  }

  activate() {
    this.resizeCanvas(undefined);
    window.addEventListener('resize', () => { this.resizeCanvas(undefined); }, true);
  }

  addFileInputListener() {

    if (!this.eventListenerActive) {
      var uploadTag = document.getElementById("sigInput");
      if (uploadTag) {
        this.eventListenerActive = true;
      }
    }

  }

  resizeCanvasWithDelay() {
    setTimeout(() => { this.resizeCanvas(true); }, 0);
  }

  resizeCanvas(forceUpdate) {

    var wrapper = document.getElementById('penSigContainer');
    var canvasObj = document.getElementById('penSigCanvasObj');

    if (wrapper && canvasObj) {
      var style = window.getComputedStyle(wrapper);
      var w = parseInt(style.width) - 2;
      if (forceUpdate != true && w == this.lastCanvasWidth)
        return;
      this.lastCanvasWidth = w;

      canvasObj.style.width = w + 'px';
      //canvasObj.firstChild.childNodes[0].width = w;
      canvasObj.style.width = w + 'px';

      setTimeout(() => {
        this.refreshPenSignature = this.refreshPenSignature + 1;
      }, 0);
    }
  }

  addSignatureById(id) {
    //$uibModalInstance.close();
    //onAddSignatureById(id);
  }

  async addPenSignature() {
    //await this.activeModal.close(undefined);

    var points = this.penSignaturePoints;

    var minX = Number.MAX_VALUE;
    var minY = Number.MAX_VALUE;

    for (var i = 0; i < points.length; i = i + 2) {
      minX = Math.min(minX, points[i]);
      minY = Math.min(minY, points[i + 1]);
    }

    for (var i = 0; i < points.length; i = i + 2) {
      points[i] -= minX;
      points[i + 1] -= minY;
    }
    this.activeModal.close(this.onAddPenSignature(points, this.newPenSignatureTitle, this.saveSignature));
  }

  penDrawStarted() {
    this.penSignatureHasContent = true;
  }

  async addImageSignature() {
    await this.activeModal.close(this.onAddImageSignature(this.imageSignature, this.newImgSignatureTitle, this.saveSignature));
  }

  async addTextSignature() {
    await this.activeModal.close(this.onAddTextSignature(this.newTextSignature, this.textSignatureFamily, this.newTxtSignatureTitle, this.saveSignature));
  }

  clearImageSignature() {
    this.imageSignature = undefined;
    var formTag = document.getElementById('sigInputForm') as HTMLFormElement;
    if (formTag) {
      formTag.reset();
    }
  }

  deleteSigById(id) {

    this.signature.deleteSignature(id).then(
      data => {

        var ok = true;
        var msg = "";

        if (data === undefined) {
          msg = this.translateService.instant('ErrorDeleteSignature');
          ok = false;
        } else if (data['status'] === 0) {
          msg = null;
          ok = true;
        } else if (data['status'] === 401) {
          msg = this.translateService.instant('LoginToUseSignature');
          ok = false;
        } else {
          msg = this.translateService.instant('ErrorDeleteSignature');
          ok = false;
        }

        setTimeout(() => {
          if (ok) {
            // Delete signature from the list
            for (var i = 0; i < this.items.length; i++) {
              if (this.items[i].id == this.itemToDelete.id) {
                this.items.splice(i, 1);
                break;
              }
            }
          } else {
            this.errorMsg = msg;
            this.error = true;
          }
        }, 1000);
    });
  }

  async cancel() {
    await this.activeModal.close(undefined);
  }

  startDeleting(item) {
    this.deleting = true;
    this.itemToDelete = item;
  }

  cancelDelete() {
    this.itemToDelete = null;
    this.deleting = false;
  }

  confirmDelete() {
    if (!this.itemToDelete)
      return;

    this.itemToDelete.deleting = true;
    this.deleteSigById(this.itemToDelete.id);
    this.deleting = false;
  }

  updatePenSignaturePoints(points) {
    this.penSignaturePoints = this.penSignaturePoints.concat(points.points);
  }

  dragEnter() {
    this.dragClass = 'dropHere-active';
  }

  dragLeave() {
    this.dragClass = 'dropHere-inactive';
  }

  fileDropped(files) {
    this.dragClass = 'dropHere-inactive';
    this.upload(files[0]);
  }

  openFileBrowser() {
    var uploadTag = document.getElementById("sigInput");
    if (uploadTag) uploadTag.click();
  }

  uploadFileFromFileInput() {
    this.upload(undefined);
  }

  upload(paramF, isDragNDrop: boolean = false) {
    var f = document.getElementById("sigInput") as HTMLInputElement;

    var file;
    if (isDragNDrop) {
      if (paramF)
        file = paramF;
      else
        file = f.files[0];
    } else {
      file = f.files[0];
    }

    var fileName = file.name;
    var fileType = "";

    if (file.type === "image/jpeg" || file.name.toLowerCase().endsWith(".jpg") || file.name.toLowerCase().endsWith(".jpeg")) {
      fileType = "jpg";
    } else if (file.type === "image/gif" || file.name.toLowerCase().endsWith(".gif")) {
      fileType = "gif";
    } else if (file.type === "image/png" || file.name.toLowerCase().endsWith(".png")) {
      fileType = "png";
    }

    if (fileType === "") {
      this.dialogs.openMessageDialog(this.translateService.instant('SelectDocument'), this.translateService.instant('UnsupportedFileFormat'));
      this.resetFileInput();
      return;
    }

    var data = new FormData();
    data.append('Image', file);

    this.imgSigLoading = true;

    ///PREVERI ZAKAJ TA FUNKCIJA NE DELA applySignatureFilter ZAČASNO ZAMENJANA Z prepareImageToInsertToDoc
    this.signature.prepareImageToInsertToDoc(this.doc, this.page, data, fileType).then(
      data => {
        this.imgSigLoading = false;
        if (data !== undefined && data['status'] === 0) {
          this.imageSignature = data['image'];
        }
      }
    );

  }

  resetFileInput() {
    var form = document.getElementById("sigInputForm") as HTMLFormElement;
    if (form) form.reset();
  }


}
